import { Modal } from 'react-bootstrap';
import styled from 'styled-components';




const GoalCardContainer = styled.div`
  border-radius: 12px;
  position: relative;
  padding:16px;
  border: 1px solid var(--Serene-Blue-500, #92A4DA);
  background: var(--Serene-Blue-200, #E7EEF8);
  min-height: 111px;
  height:auto;
  align-self: stretch;
  margin-bottom: 20px;

  .myGoalHeading{
    color:  #092F41;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
  }

  .goalText{
    width:258px;
    word-break: break-word;
    color: #092F41;
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
   margin-top:4px;
   margin-bottom:20px;
  }

  .goalIcon{
    position: absolute;
    ${'' /* top:44px; */}
    bottom:-3px;
    right:-3px;
  }

`;



const TaskContainer = styled.div`
  display: flex;
  padding: 20px;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
  align-self: stretch;
  border-radius: 12px;
  border: 0.75px solid var(--Crimson-Blush-300, #EEB3B4);
  background: var(--Crimson-Blush-500, #FCF2F3);

.taskHeading{
   display:flex;
   flex-direction:column;
    gap:8px;
}

  .completionContainer{
     display: flex;
     align-items: center;
     gap: 8px;
     margin-top: 16px;
  }

  `;


const TextContainer = styled.div`
  color: ${({isTextColor})=> isTextColor ? isTextColor : '#184A61'};
  font-family: Lato;
  font-size: ${({isFontSize})=> isFontSize ? isFontSize : '16px'};
  font-style: normal;
  font-weight: ${({isFontWeight})=> isFontWeight ? isFontWeight : '400'};
  line-height: ${({isLineHeight})=> isLineHeight ? isLineHeight : '20px'};
  text-align: ${({isTextAlign})=> isTextAlign ? isTextAlign : 'left'};
  margin:${({isMargin})=> isMargin ? isMargin : '0'};
`;



const ShowLessMoreTextContainer = styled.div`
  color: ${({isTextColor})=> isTextColor ? isTextColor : '#184A61'};
  font-family: Lato;
  font-size: ${({isFontSize})=> isFontSize ? isFontSize : '16px'};
  font-style: normal;
  font-weight: ${({isFontWeight})=> isFontWeight ? isFontWeight : '400'};
  line-height: ${({isLineHeight})=> isLineHeight ? isLineHeight : '20px'};
  text-align: ${({isTextAlign})=> isTextAlign ? isTextAlign : 'left'};
  margin:${({isMargin})=> isMargin ? isMargin : '0'};
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => (props.isExpanded ? "unset" : 2)};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: ${(props) => (props.isExpanded ? "none" : "40px")};

`;



const ShowLessContent = styled.div`
color: #184A61;
font-family: Lato;
font-size: 16px;
cursor:pointer;
font-style: normal;
font-weight: 400;
line-height: 20px; 
text-decoration-line: underline;
text-decoration-style: solid;
text-decoration-skip-ink: none;
text-decoration-thickness: auto;
text-underline-offset: auto;
text-underline-position: from-font;
`;





export const CheckBoxContainer = styled.div`
    display:flex;
    align-items:center;
    .selection{
      border-radius: 4px;

    border:${({selected, disabled}) => disabled?'1px solid #FEFEFE': selected ? '1px solid #DA6C74' : '1px solid #DA6C74'};
    background:${({selected,disabled}) => disabled?'#EFEFEF': selected ? '#F37A65' : '#FCF2F3'};
    width: 20px;
    height: 20px;
    position: relative;
    cursor:${({isCursor}) => isCursor ? isCursor : 'pointer'};
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; 
    }
    .archive-action{
    border-radius: 4px;
    border:${({selected, disabled}) => disabled?'1px solid #BDBDBD': selected ? '1px solid #F37A65' : '1px solid #7C7C7C'};
    background:${({disabled}) => disabled?'#EFEFEF': '#F8F8F8'};
    width:20px;
    height:20px;
    position:relative;
    cursor:${({isCursor}) => isCursor ? isCursor : 'pointer'};
    ${'' /* cursor:pointer; */}
    >svg{
        position:absolute;
        right:2px;
        top:3px;
    }
}
`




const TaskCalendar = styled.div`
  width: 100%;
    
  .react-calendar {
    width: 100% !important;
    border: none;
    background: white;
  }

  /* Header (month + arrows) */
  .react-calendar__navigation {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    button {
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .react-calendar__navigation__arrow {
  display: none !important;
}


   .react-calendar__tile.future {
     background: #F8F8F8 !important;
     color: #7C7C7C !important;
     cursor: not-allowed;
   }
   .react-calendar__month-view__weekdays abbr {
     text-decoration: none !important;
     border-bottom: none !important;
     cursor: default;
   }

   .react-calendar__month-view__weekdays__weekday:hover {
     background: transparent !important;
   }


  /* Week days */
  .react-calendar__month-view__weekdays {
    text-align: center;
    font-size: 16px;
    height:36px;
    color: #BDBDBD !important;
    margin-bottom:16px;
    font-weight: 400 !important;
l   line-height: 20px !important;
  }

  /* Grid layout */
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    height:208px;
  }

   

  /* Each day tile */
  .react-calendar__tile {
    height: 28px;
    border-radius: 4px;
    border: none;
    background: #f8f8f8;
    font-size: 16px;
    font-weight:400;
    line-height:20px;
    color: #184a61;
  }

  /* Hide outside month days */
        .react-calendar__month-view__days__day--neighboringMonth {
          opacity: 0;
          pointer-events: none;
        }
      
        .react-calendar__navigation__label {
          pointer-events: none;   
          cursor: default;   
          flex-grow: 0 !important;
        }
       
         .react-calendar__navigation {
         justify-content: center;
       }
       
       .react-calendar__navigation__arrow {
         display: none !important;
       }
       
       .react-calendar__navigation__label {
         flex-grow: 0 !important;
         pointer-events: none;   /* ❌ disable click */
         cursor: default;   
         font-weight: 600;
         color: #0F3D5E; /* match your design */
       }
       
       
       
         .react-calendar__navigation button {
          display: none;
         }
         
         .react-calendar__navigation__label {
          pointer-events: none;   /* ❌ disable click */
          cursor: default;   
           display: block !important;
         }
       
       
         .react-calendar__navigation__label {
         background: none !important;
         font-weight: 700;
         font-size: 16px;
         color: #184a61;   /* Figma dark blue */
        }
        
        .react-calendar__navigation__label span {
          color: #184a61;
        }
       
       
        .react-calendar__navigation {
         justify-content: center;
         gap: 12px;
         margin-bottom:16px !important;
       }


  /* Today (blue like Figma) */
 
  /* Selected / completed */
    .completed {
      background: #DDEEDF !important;
    }
  
    /* Not completed */
    .missed {
      background: #FDD2CB !important;
    }
  
    .react-calendar__tile.na {
    background: #DCDCDC !important;
    color: #7C7C7C !important;
    cursor: not-allowed;
  }
  
  .future {
    background-color: #F8F8F8 !important;
    color: #BDBDBD !important;
    pointer-events: none; /* ❌ no click */
  }

  .na {
    background: #DCDCDC !important;
    color: #7C7C7C !important;
    cursor: not-allowed;
  }
  ${'' /* .react-calendar__tile--now {
    background: #D3DEF2 !important;
    border: 1px solid #92A4DA !important;
    border-radius: 4px; 
    color: #184A61;
  } */}

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #D3DEF2 !important;
    ${'' /* border: 1px solid #92A4DA !important; */}
  }


    ${'' /* .react-calendar__tile.selected {
    border-radius: 4px;
    border: 1px solid var(--Serene-Blue-500, #92A4DA);
    background: var(--Serene-Blue-300, #D3DEF2) !important;
    color: #184A61;
  } */}

  
  .react-calendar__tile.selected {
  border-radius: 4px;
  ${'' /* border: 1px solid var(--Serene-Blue-500, #92A4DA); */}
  background: var(--Serene-Blue-300, #D3DEF2) !important;
  color: #184A61;
}
  
  /* Ensure selected overrides completed/missed */
  .react-calendar__tile.completed.selected,
  .react-calendar__tile.missed.selected {
    background: var(--Serene-Blue-300, #D3DEF2) !important;
    ${'' /* border: 1px solid var(--Serene-Blue-500, #92A4DA); */}
  }

`;





const FeelingCard = styled.div`
  cursor: pointer;
  text-align: center;
  padding: 6px;
  border-radius: 4px;
  background: transparent;
  min-width:100px;
  ${'' /* border: 1px solid transparent; */}

  &.active {
    background: var(--Green-Serenity-100, #F1F8F2);
    ${'' /* border: 2px solid #75B084; */}
  }

  .emoji {
    font-size: 24px;
  }

  .label {
    margin-top: 4px;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; 
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    text-align: center;
  }
`;



const DateWrapper = styled.div`
display: flex;
align-items: flex-start;
gap: 10px;


.date{
    color: #184A61;
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 16px; 
padding: 8px;
background:#EFEFEF;

}
`;


const JournalContainer = styled.div`
   display: flex;
   ${'' /* margin-top:12px; */}
   width:764px;
   flex-direction: column;
   padding: 16px;
   flex-direction: column;
   justify-content: center;
   align-items: flex-start;
   gap: 20px;
   ${'' /* align-self: stretch; */}
   border-radius: 12px;
   border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
   background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);


   .journalContent{
         display:flex;
         gap:20px;

         .aboutext{
          margin-top:8px;
         }

    }


    .feelingIcon{
      width: 40px;
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
      margin: auto;
    }

`;



const DateContainer = styled.div`
  display: flex;
  width:125px;
  height:32px;
  padding: 8px;
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: var(--Bg-Color-for-Light-theme-400, #EFEFEF);
  `;





const NoJournalContainer = styled.div`
  display: flex;
  height: 136px;
  padding: 16px;
  width:764px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  border-radius: 12px;
  background: var(--Serene-Blue-100, #F2F5FB);

  .row-one{
    display:flex;
    gap:16px;
    align-items:center
  }

  .plusIcon{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    ${'' /* margin-top:20px; */}
    height: 40px;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    cursor:pointer;
    gap: 8px;
    border-radius: 24px;
    background: #FFF;
  }
  `;




const QuizContainer = styled.div`
  display: flex;
  gap: 24px;
  max-width: 1248px;
  min-height: 252px;
  background: var(--Light-Card, rgba(254, 254, 254, 0.60));
  padding: 16px;
  border-radius: 12px;
  margin: ${({ margin }) => margin || "0"};

  .section {
    flex: 1; /* default full width */
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  /* when both sections exist, share half */
  .section:not(.full) {
    ${'' /* flex: 0 0 50%; */}
    max-Width:596px;
  }

  .journal-box {
    padding: 16px;
    background: #FEFEFE;
    border-radius: 12px;
    border: 1px solid #DCDCDC;
    ${'' /* display: flex; */}
    ${'' /* align-items: center; */}
  }

  .title {
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  .taskDesc {
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #184A61;
    border-radius: 4px;
    background: #F8F8F8;
    padding: 16px;
    width:100%;
    margin-top:16px;
  }

  .taskTitle {
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: #184A61;
    margin-bottom: 8px;
  }
`;
  


const StyledModal = styled(Modal)`

   display: flex !important;
   align-items: center !important;
   justify-content: center !important;

  .modal-dialog {
    display: flex !important;
   align-items: center !important;
   justify-content: center !important;
    width: ${(props) => props.isWidth || '600px'} !important;
    max-width: ${(props) => props.isWidth || '600px'} !important;
    ${'' /* padding:0  !important;  */}
    margin: auto !important;
    

    .modal-content{
      width: ${(props) => props.isWidth || '600px'} !important;
      max-width: ${(props) => props.isWidth || '600px'} !important;
      border-radius: 7px 7px 6px 6px;
      height: ${(props) => props.isHeight || 'auto'} !important;
      ${'' /* height:  ${(isHeight) => isHeight ? isHeight : 'auto'} !important; */}
    }
    .modal-header {
      background: linear-gradient(180deg,#52A8ED 0%,#8AD3F7 100%);
      border-radius: 6px 6px 0px 0px;
    }
    .modal-body{
      .text{
        color: #184A61;
        text-align: center;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      padding: ${(isPadding) => isPadding ? isPadding : '0px 0 0 0'};
      ${'' /* height: 454px; */}
      overflow-y: auto;
      .text{
        color: #184A61;
        text-align: center;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      ::-webkit-scrollbar {
       width: 10px;

     }

::-webkit-scrollbar {
   width: 5px;
   height: 5px;
 }
  ::-webkit-scrollbar-thumb {
   background: #BDBDBD;
   cursor: pointer;
   border-radius: 2.5px;
 }

::-webkit-scrollbar-track {
  background: #FEFEFE; 
  border-radius: 6px;
}
 

    }
    @media (max-width: 1000px) {
      ${'' /* width: 60%; */}
      width: ${(props) => props.$width || '60%'};
      max-width: ${(props) => props.$width || '60%'};
    }
    
    @media (max-width: 767px) {
      ${'' /* width: 90%; */}
      width: ${(props) => props.$width || '90%'};
      max-width: ${(props) => props.$width || '90%'};
      margin: 30px auto;
    }
  }

  .downloadButton{
    display: flex;
    justify-content: center;
    margin: 20px auto 12px auto;
  }
`;


export {GoalCardContainer, TaskContainer, ShowLessContent,ShowLessMoreTextContainer, QuizContainer,StyledModal, NoJournalContainer,  DateContainer, TextContainer, TaskCalendar, FeelingCard, DateWrapper, JournalContainer};
